export default {
    environment: 'debug',     //debug or online
    api: {
        // url: 'https://api.shengmingshuo.com',//正式
        url: 'http://api.shopdev.shengmingshuo.com',
        // url: 'http://sms.huajit.com', //测试地址
        // url: 'http://10.8.7.35:8014', // 本地地址
        // url: 'http://10.8.7.36:8013', // 本地2
        websocket: 'ws://sms.huajit.com/ws/chat'
    },
    chat: {
        title: '生命说客服系统'
    }
}


// WEBPACK FOOTER //
// ./.config.js